import { Store } from './../../store';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CasestudyService } from '../../services/casestudy.service';
import { BreadcrumbsService } from '../../services/breadcrumbs.service';
import { SeoService } from 'src/app/services/seo.service';

@Component({
    selector: 'app-case-study-public',
    templateUrl: './case-study-public.component.html',
    styleUrls: ['./case-study-public.component.scss']
})
export class CaseStudyPublicComponent implements OnInit {
    deviceType$ = this.store.select<string>('deviceType');
    caseStudy: any;

    constructor(
        private route: ActivatedRoute,
        private casestudyService: CasestudyService,
        private store: Store,
        private breadcrumbsService: BreadcrumbsService,
        private seoService: SeoService,
    ) { }

    ngOnInit(): void {
        this.casestudyService.get(this.route.snapshot.params.slug).subscribe(data => {
            this.caseStudy = data.data;
            this.breadcrumbsService.changeBreadcrumb([
                { text: 'Case Studies', route: ['/case-studies'] },
                { text: this.caseStudy.title }
            ]);
            this.setMetaTags(data.data);
        });
    }

    setMetaTags(data) {
        this.seoService.updateTitle(data.title);
        this.seoService.addMetaTag('description', data.previewParagraph);
        this.seoService.createLinkForCanonicalURL();
    }

}
